import React from 'react';
import { Helmet } from 'react-helmet-async';

import { useLocation } from 'src/shared/hooks';

import {
  oneSignalInitializerSnippet,
  oneSignalSWLoaderSnippet,
} from './snippets';

const BeaconAppID = '2be7026a-7166-4972-b614-0ae51b3a7852';
const HoverAppId = '6359384a-8f05-4359-ae2b-49eb90fd60e2';

const OneSignal = () => {
  const { hostname, protocol } = useLocation();

  if (!protocol.includes('https')) return null;

  const appID = hostname.includes('beacon.hover.to') ? BeaconAppID : HoverAppId;
  const shouldEnableOneSignal = ['hover.to', 'beacon.hover.to'].includes(
    hostname,
  );

  // OneSignal integration is only allowed on hover.to and beacon.hover.to
  // Other partner pages will not yet get OneSignal integration due to marketing decisions
  if (shouldEnableOneSignal)
    return (
      <Helmet>
        <script
          defer
          src="https://cdn.onesignal.com/sdks/web/v16/OneSignalSDK.page.js"
        />
        <script>{oneSignalInitializerSnippet(appID)}</script>
        <script>{oneSignalSWLoaderSnippet}</script>
      </Helmet>
    );

  // eslint-disable-next-line no-console
  console.error('Current subdomain does not support OneSignal integration.');

  return null;
};

export { OneSignal };
